import React from 'react';
import { ReceivingOrder } from '../receivingTypes';
import styles from './ReceivingTable.module.css';

interface ReceivingTableProps {
  orders: ReceivingOrder[];
  onSelectOrder: (order: ReceivingOrder) => void;
}

export const ReceivingTable: React.FC<ReceivingTableProps> = ({ orders, onSelectOrder }) => {
  const getStatusClass = (status: ReceivingOrder['status']) => {
    switch (status) {
      case 'Pending':
        return styles.badgePending;
      case 'Partial':
        return styles.badgePartial;
      case 'Completed':
        return styles.badgeCompleted;
      default:
        return '';
    }
  };

  const renderActionButton = (order: ReceivingOrder) => {
    switch (order.status) {
      case 'Pending':
        return (
          <button className={styles.btnStartPicking} onClick={() => onSelectOrder(order)}>
            Start Picking
          </button>
        );
      case 'Partial':
        return (
          <button className={styles.btnContinue} onClick={() => onSelectOrder(order)}>
            Continue
          </button>
        );
      case 'Completed':
        return (
          <button className={styles.btnViewDetails} onClick={() => onSelectOrder(order)}>
            View Details
          </button>
        );
      default:
        return null;
    }
  };

  return (
    <div className={styles.card}>
      <h2 className={styles.title}>Receiving Queue</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Vendor Name</th>
              <th>PO Reference</th>
              <th>Expected Date</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.id}>
                <td className={styles.vendorName}>{order.vendorName}</td>
                <td>{order.poReference}</td>
                <td>{order.expectedDate}</td>
                <td>
                  <span className={getStatusClass(order.status)}>{order.status}</span>
                </td>
                <td>{renderActionButton(order)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
